<template>
  <div :class="gridClass">
    <label class="block text-sm font-medium text-gray-700 mb-2">
      {{ label }} <span v-if="required" class="text-red-500">*</span>
    </label>
    <div class="space-y-2 max-h-[190px] overflow-y-auto border border-gray-300 rounded-lg p-3">
      <label 
        v-for="category in categories" 
        :key="category.value"
        class="flex items-center hover:bg-gray-50 rounded transition-colors"
      >
        <input
          :value="category.value"
          type="checkbox"
          :checked="isSelected(category.value)"
          @change="toggleCategory(category.value)"
          class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
        />
        <span class="ml-2 text-sm text-gray-700">{{ category.label }}</span>
      </label>
    </div>
    <p v-if="selectedCount > 0" class="text-sm text-blue-600 mt-2">
      {{ selectedCount }} catégorie(s) sélectionnée(s)
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { ProductCategoriesFieldProps } from '@/types/sellerRegister';

const props = withDefaults(defineProps<ProductCategoriesFieldProps>(), {
  required: false,
  gridClass: ''
});

const emit = defineEmits<{
  'update:modelValue': [categories: string[]];
}>();

// Catégories disponibles
const categories: Array<{ value: string; label: string }> = [
  { value: 'femmes', label: 'Femmes' },
  { value: 'femmes-grande-taille', label: 'Femmes Grande Taille' },
  { value: 'hommes', label: 'Hommes' },
  { value: 'enfants', label: 'Enfants' },
  { value: 'chaussures-femmes', label: 'Chaussures femmes' },
  { value: 'chaussures-hommes', label: 'Chaussures hommes' },
  { value: 'chaussures-enfants', label: 'Chaussures enfants' },
  { value: 'maroquinerie', label: 'Maroquinerie' },
  { value: 'accessoires', label: 'Accessoires' }
];

const selectedCount = computed(() => props.modelValue.length);

const isSelected = (value: string) => {
  return props.modelValue.includes(value);
};

const toggleCategory = (value: string) => {
  const newSelection = [...props.modelValue];
  if (isSelected(value)) {
    // Retirer la catégorie
    const index = newSelection.indexOf(value);
    newSelection.splice(index, 1);
  } else {
    // Ajouter la catégorie
    newSelection.push(value);
  }
  emit('update:modelValue', newSelection);
};
</script>
